import { useContext } from "react";
import { useDispatch } from "react-redux";
import { contextProvider } from "../../../../context/ContextProvider";
import { DateRange } from "react-date-range";
import { addDays } from "date-fns";
import { useState } from "react";
import Input from "../../../components/custom/forms/Input";
import { Validate, dateRange, sortDescDate } from "../../../../utils/EventoUtils";
import Alerts from "../../../components/Alerts/Alerts";

const Cuando = ({
  setForm,
  form,
  setValidation,
  validation,
  locale,
  setFecha,
  fecha,
}) => {
  const dispatch = useDispatch();
  const context = useContext(contextProvider);
  const { FORMs, VALIDATIONs, URLs } = context;

  const { VALIDATION_FORM_EVENTO, VALIDATION_FORM_EVENTO_SALA } = VALIDATIONs;
  const { FORM_EVENTO_SALA, FORM_EVENTO } = FORMs;
  const { URL_SALA_SEARCH } = URLs;

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "fecha-hora":
      case "fecha-stock":
        {
          let input = form;
          input[e.target.name][0] = e.target.value;

          setForm({
            ...form,
            [e.target.value]: input[e.target.name],
          });
        }
        break;
      case "day-stock":
        {
          let input = form;
          let result = input.fechas[0];

          result[e.target.id].stock = e.target.value;

          setForm({
            ...form,
            fechas: [result, ""],
          });
        }
        break;
    }
  };

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "fecha-day":
        {
          let input = form;
          let result = form["fecha-day"][0];

          if (result.indexOf(value) < 0) {
            result.push(value);
          } else {
            delete result[result.indexOf(value)];
            result = result.filter((i) => i != null);
          }

          input["fecha-day"][0] = result;

          setForm({
            ...form,
            ["fecha-day"]: input["fecha-day"],
          });
        }
        break;
      case "fecha-añadir":
        {
          const input_validation = Validate(form, JSON.parse(JSON.stringify(VALIDATION_FORM_EVENTO)), "fecha");
          setValidation(input_validation);
          //Validaciones
          if (input_validation.error.status) {
            return Alerts({
              msg: "Warning",
              title: input_validation.error.msg,
              code: "404",
              type: "error",
            });
          }

          let input = form;

          let fechas = dateRange(fecha, setForm, form);
          if (!fechas) return ""

          input.fechas[0] = fechas;

          setForm({
            ...form,
            fechas: input.fechas,
          });

          Alerts({
            msg: "Success",
            title: `Se ${fechas.length > 1 ? 'agregaron ' + fechas.length + ' fechas' : 'agregó 1 fecha'} correctamente`,
            code: "200",
            type: "success",
          });
        }
        break;
      case "fecha-delete":
        {
          let input = form;
          let result = input.fechas[0];


          let exits = false;
          form.reportes[0].map((re) => {
            if (re.fecha == result[value].fechas[0] + ' HORA: ' + result[value].hora) {
              exits = true;
            }
          })

          if (exits) {
            return Alerts({
              msg: "Warning",
              title: "No puedes eliminar esta fecha porque contiene entradas vendidas",
              code: "201",
              type: "error",
            });
          }

          // Confirmación antes de eliminar
          if (!window.confirm(`¿Estás seguro de eliminar la fecha ${result[value].fechas[0]} - ${result[value].hora}?`)) {
            return;
          }

          delete result[value];
          result = result.filter((i) => i != null);

          setForm({
            ...form,
            fechas: [result, "required"],
          });

          Alerts({
            msg: "Success",
            title: "Fecha eliminada correctamente",
            code: "200",
            type: "success",
          });
        }
        break;
    }
  };

  return (
    <div className="container-md w-100 tw-space-y-6">
      <div
        className="border p-3 mb-4 tw-bg-white tw-shadow-lg tw-border-gray-200 tw-transition-all hover:tw-shadow-xl"
        style={{ borderRadius: "1rem" }}
      >
        <div className="row">
          <div className="col-md-12 mb-3 px-1">
            <h5 className="GothamBold d-flex align-items-center tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-4">
              <i className="bi bi-calendar-event me-2 text-dark tw-mr-3 tw-text-orange-600 tw-text-3xl"></i>
              Fecha y hora de funciones
              <span className="badge bg-danger ms-2 tw-ml-3 tw-px-3 tw-py-1 tw-text-xs tw-bg-red-500 tw-text-white tw-rounded-full tw-animate-pulse" style={{ fontSize: "0.7rem" }}>Obligatorio</span>
            </h5>
            <p className="text-muted small mb-3 tw-flex tw-items-center tw-text-gray-600 tw-bg-orange-50 tw-p-3 tw-rounded-lg">
              <i className="bi bi-info-circle me-1 tw-text-orange-500 tw-text-lg tw-mr-2"></i>
              Selecciona el rango de fechas, los días de la semana disponibles, la hora y la capacidad
            </p>
            <hr className="tw-border-t-2 tw-border-gray-200 tw-my-4" />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <h6 className="d-flex align-items-center mb-3 tw-text-lg tw-font-bold tw-text-gray-700 tw-mb-4">
              <i className="bi bi-calendar-range me-2 text-dark tw-text-orange-500 tw-text-2xl tw-mr-3"></i>
              1. Selecciona el rango de fechas
            </h6>
            <div className="border rounded p-2 mb-3 tw-border-2 tw-border-gray-300 tw-rounded-xl tw-shadow-md tw-overflow-hidden" style={{ backgroundColor: "#fafafa" }}>
              <DateRange
                editableDateInputs={true}
                onChange={(item) => setFecha([item.selection])}
                moveRangeOnFirstSelection={false}
                locale={locale}
                minDate={addDays(new Date(), 0)}
                ranges={fecha}
                style={{ fontSize: "12px" }}
                color={"#d0552a"}
                showDateDisplay={false}
                rangeColors={["#d0552a", "#d0552a", "#d0552a"]}
              />
            </div>

            <div className="mb-3">
              <h6 className="d-flex align-items-center mb-2 tw-text-lg tw-font-bold tw-text-gray-700 tw-mb-3">
                <i className="bi bi-calendar-week me-2 text-dark tw-text-orange-500 tw-text-2xl tw-mr-3"></i>
                2. Selecciona los días de la semana
              </h6>
              <p className="text-muted small mb-2 tw-flex tw-items-center tw-text-gray-600 tw-bg-gray-50 tw-p-2 tw-rounded-lg tw-mb-3">
                <i className="bi bi-hand-index me-1 tw-text-orange-500 tw-mr-2"></i>
                Haz clic en los días que estarán disponibles (botones verdes = seleccionados)
              </p>
              <div className="d-flex flex-wrap gap-2 tw-gap-2">
                {[
                  { name: "domingo", abbr: "Dom", icon: "bi-sun" },
                  { name: "lunes", abbr: "Lun", icon: "bi-calendar2-day" },
                  { name: "martes", abbr: "Mar", icon: "bi-calendar2-day" },
                  { name: "miércoles", abbr: "Mié", icon: "bi-calendar2-day" },
                  { name: "jueves", abbr: "Jue", icon: "bi-calendar2-day" },
                  { name: "viernes", abbr: "Vie", icon: "bi-calendar2-day" },
                  { name: "sábado", abbr: "Sáb", icon: "bi-moon-stars" },
                ].map((d) => {
                  const isSelected = form["fecha-day"][0].includes(d.name);
                  return (
                    <label
                      key={d.name}
                      className={`btn ${isSelected ? 'btn-dark' : 'btn-outline-dark'} flex-grow-1 tw-transition-all tw-duration-200 hover:tw-scale-105 tw-rounded-xl ${isSelected ? 'tw-bg-orange-600 tw-border-orange-600 hover:tw-bg-orange-700' : 'tw-border-gray-300 hover:tw-border-orange-400'}`}
                      style={{
                        minWidth: "80px",
                        cursor: "pointer",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <div className="d-flex flex-column align-items-center tw-py-1">
                        <i className={`bi ${d.icon} mb-1 tw-text-xl`}></i>
                        <small className="text-capitalize tw-font-medium">{d.name}</small>
                      </div>
                      {isSelected && (
                        <i className="bi bi-check-circle-fill position-absolute top-0 end-0 m-1 tw-text-green-400" style={{ fontSize: "0.9rem" }}></i>
                      )}
                      <button
                        className="d-none"
                        name="fecha-day"
                        onClick={(event) => onClick(event, d.name)}
                      ></button>
                    </label>
                  );
                })}
              </div>
              <div className="mt-2 tw-mt-3">
                <small className={`badge tw-px-4 tw-py-2 tw-rounded-full tw-font-semibold tw-transition-all ${form["fecha-day"][0].length > 0 ? 'bg-success tw-bg-green-500' : 'bg-secondary tw-bg-gray-400'}`}>
                  <i className="bi bi-calendar-check me-1"></i>
                  {form["fecha-day"][0].length} día{form["fecha-day"][0].length !== 1 ? 's' : ''} seleccionado{form["fecha-day"][0].length !== 1 ? 's' : ''}
                </small>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <h6 className="d-flex align-items-center mb-2 tw-text-base tw-font-bold tw-text-gray-700 tw-mb-3">
                  <i className="bi bi-clock me-2 text-dark tw-text-orange-500 tw-text-xl tw-mr-2"></i>
                  3. Hora de la función
                </h6>
                <Input
                  onChange={onChange}
                  label={"Hora"}
                  name={"fecha-hora"}
                  type={"time"}
                  value={form["fecha-hora"][0]}
                  svg={'<i class="bi bi-clock-fill"></i>'}
                  validate={validation["fecha-hora"]}
                  disabled={false}
                />
              </div>

              <div className="col-md-6 mb-3">
                <h6 className="d-flex align-items-center mb-2 tw-text-base tw-font-bold tw-text-gray-700 tw-mb-3">
                  <i className="bi bi-people me-2 text-dark tw-text-orange-500 tw-text-xl tw-mr-2"></i>
                  4. Capacidad
                </h6>
                <Input
                  onChange={onChange}
                  label={"Capacidad por función"}
                  name={"fecha-stock"}
                  type={"number"}
                  value={form["fecha-stock"][0]}
                  svg={'<i class="bi bi-ticket-perforated"></i>'}
                  validate={validation["fecha-stock"]}
                  disabled={false}
                />
                {form["fecha-stock"][0] > 0 && (
                  <small className="text-muted d-block mt-1 tw-flex tw-items-center tw-text-gray-600 tw-bg-blue-50 tw-p-2 tw-rounded-lg tw-mt-2">
                    <i className="bi bi-info-circle me-1 tw-text-blue-500 tw-mr-1"></i>
                    Se aplicará a todas las fechas seleccionadas
                  </small>
                )}
              </div>
            </div>

            <label className="btn btn-custom-naranja fw-normal GothamBold text-white w-100 py-2 tw-bg-gradient-to-r tw-from-orange-500 tw-to-orange-600 hover:tw-from-orange-600 hover:tw-to-orange-700 tw-transition-all tw-duration-200 tw-transform hover:tw-scale-[1.02] tw-shadow-lg hover:tw-shadow-xl tw-rounded-xl tw-py-3" style={{ cursor: "pointer" }}>
              <i className="bi bi-plus-circle me-2 tw-text-lg"></i>
              Añadir Fechas al Calendario
              <button
                className="d-none"
                name="fecha-añadir"
                onClick={(event) => onClick(event)}
              ></button>
            </label>
          </div>
          <div className="col-md-6 mt-3 mt-md-0">
            <div className="d-flex justify-content-between align-items-center mb-3 tw-mb-4">
              <h6 className="d-flex align-items-center mb-0 tw-text-lg tw-font-bold tw-text-gray-700">
                <i className="bi bi-calendar-check me-2 text-dark tw-text-orange-500 tw-text-2xl tw-mr-2"></i>
                Funciones programadas
              </h6>
              <span className={`badge tw-px-4 tw-py-2 tw-rounded-full tw-font-semibold tw-transition-all ${form.fechas[0].length > 0 ? 'bg-success tw-bg-green-500' : 'bg-secondary tw-bg-gray-400'}`}>
                <i className="bi bi-calendar-event me-1"></i>
                {form.fechas[0].length} función{form.fechas[0].length !== 1 ? 'es' : ''}
              </span>
            </div>

            {form.fechas[0].length === 0 ? (
              <div className="text-center text-muted py-5 border rounded bg-light tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-gray-50 tw-border-2 tw-border-dashed tw-border-gray-300 tw-rounded-2xl tw-py-12">
                <i className="bi bi-calendar-x tw-text-7xl tw-text-gray-300 tw-mb-4" style={{ fontSize: "3rem", opacity: 0.3 }}></i>
                <p className="mt-3 mb-0 tw-text-gray-500 tw-font-medium">No hay funciones agregadas</p>
                <small className="tw-text-gray-400">Configura el calendario y añade tus fechas</small>
              </div>
            ) : (
              <div style={{ maxHeight: "600px", overflowY: "auto" }} className="tw-space-y-3">
                <ul className="list-group tw-space-y-2">
                  {sortDescDate(form.fechas[0]).map((f, index) => {
                    // Verificar si tiene entradas vendidas
                    let hasTickets = false;
                    if (form.reportes && form.reportes.length > 0) {
                      form.reportes[0].forEach((re) => {
                        if (re.fecha == f.fechas[0] + ' HORA: ' + f.hora) {
                          hasTickets = true;
                        }
                      });
                    }

                    return (
                      <li key={index} className="list-group-item border shadow-sm mb-3 p-3 tw-bg-white tw-border-2 tw-border-gray-200 tw-rounded-xl tw-p-4 tw-transition-all hover:tw-shadow-lg hover:tw-scale-[1.01]">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="flex-grow-1">
                            <div className="d-flex align-items-center mb-2 tw-flex tw-items-center tw-mb-3">
                              <i className="bi bi-calendar-event-fill text-dark me-2 tw-text-orange-500 tw-text-xl tw-mr-2"></i>
                              <strong className="text-dark tw-text-gray-800 tw-font-bold">{f.fechas[0]}</strong>
                              <i className="bi bi-clock-fill text-dark mx-2 tw-text-orange-500 tw-text-lg tw-mx-3"></i>
                              <strong className="text-dark tw-text-gray-800 tw-font-bold">{f.hora}</strong>
                            </div>
                            {hasTickets && (
                              <div className="alert alert-warning py-1 px-2 mb-2 d-inline-flex align-items-center tw-bg-yellow-50 tw-border-l-4 tw-border-yellow-500 tw-p-2 tw-rounded-r-lg">
                                <i className="bi bi-exclamation-triangle-fill me-1 tw-text-yellow-600 tw-mr-2" style={{ fontSize: "0.8rem" }}></i>
                                <small className="tw-text-yellow-700 tw-font-medium">Tiene entradas vendidas - No se puede eliminar</small>
                              </div>
                            )}
                          </div>
                          <button
                            className={`btn ${hasTickets ? 'btn-outline-secondary' : 'btn-outline-danger'} btn-sm tw-transition-all tw-duration-200 hover:tw-scale-110 ${!hasTickets ? 'hover:tw-bg-red-500 hover:tw-text-white' : ''}`}
                            onClick={(event) => {
                              event.target.name = "fecha-delete";
                              onClick(event, index);
                            }}
                            disabled={hasTickets}
                            title={hasTickets ? "No se puede eliminar - Tiene ventas" : "Eliminar función"}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                        <Input
                          onChange={onChange}
                          label={"Capacidad de esta función"}
                          name={"day-stock"}
                          type={"number"}
                          value={f.stock}
                          uniqueKey={index}
                          svg={'<i class="bi bi-ticket-perforated"></i>'}
                          validate={{ msg: "", status: false }}
                          disabled={false}
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cuando;
